import { z } from 'zod';
import { schemas } from '@kreart/shared';

export interface ClientsListSearch {
  page?: number;
  pageSize?: number;
  search?: string;
  includeDeleted?: boolean;
}

const boolLoose = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((v) => (typeof v === 'string' ? v === 'true' : v));

const raw = z
  .object({
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
    search: z.string().trim().min(1).max(100).optional(),
    includeDeleted: boolLoose.optional(),
  })
  .passthrough();

export function parseClientsListSearch(
  input: Record<string, unknown>,
  opts: { isAdmin: boolean },
): ClientsListSearch {
  const parsed = raw.safeParse(input);
  if (!parsed.success) return {};
  const v = parsed.data;
  const out: ClientsListSearch = {};
  if (v.page !== undefined && v.page !== 1) out.page = v.page;
  if (v.pageSize !== undefined && v.pageSize !== 25) out.pageSize = v.pageSize;
  if (v.search) out.search = v.search;
  if (v.includeDeleted && opts.isAdmin) out.includeDeleted = true;
  return out;
}

export function toListQuery(search: ClientsListSearch) {
  return schemas.listClientsQuery.parse({
    page: search.page ?? 1,
    pageSize: search.pageSize ?? 25,
    search: search.search,
    includeDeleted: search.includeDeleted ?? false,
  });
}
